import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";
import { BrandPreviewWithBanner } from "../components/BrandPreviewWithBanner";
var BANNER_IMAGE_HEIGHT = 200;
export var BrandPreviewSection = function(param) {
    var brand = param.brand, brandToken = param.brandToken, pageJsExecutedMark = param.pageJsExecutedMark;
    return /*#__PURE__*/ _jsx(Center, {
        "data-test-id": "brand-info-section",
        children: /*#__PURE__*/ _jsx(Container, {
            children: /*#__PURE__*/ _jsx(BrandPreviewWithBanner, {
                brand: brand,
                brandToken: brandToken,
                pageJsExecutedMark: pageJsExecutedMark
            })
        })
    });
};
var Center = styled.div.withConfig({
    componentId: "sc-a2e6bfb-0"
})([
    "margin:0 auto;width:fit-content;max-width:100%;"
]);
var Container = styled.div.withConfig({
    componentId: "sc-a2e6bfb-1"
})([
    "max-width:1120px;border:1px solid ",
    ";background:",
    ";box-shadow:0 0 16px 4px rgba(0,0,0,0.12);margin:-",
    "px 24px 0;",
    "{margin:-",
    "px 80px 0;}"
], Core.border.muted, Core.surface.inverse, BANNER_IMAGE_HEIGHT + 16, responsiveMediaQueries.desktopAndAbove, BANNER_IMAGE_HEIGHT);
